import { render } from "./NotFound.vue?vue&type=template&id=6f9ff37a&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=6f9ff37a&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9ff37a"]])

export default __exports__